import { retainAvailable, selectAll } from "./selection.ts";

export class TaskSelectionState {
  active = false;
  ids = new Set<string>();

  setActive(active: boolean): void {
    this.active = active;
  }

  replace(ids: Set<string>): void {
    this.ids = ids;
  }

  toggleMode(): boolean {
    this.active = !this.active;
    this.ids.clear();
    return this.active;
  }

  clear(): void {
    this.active = false;
    this.ids.clear();
  }

  retain(ids: string[]): void {
    this.ids = retainAvailable(this.ids, ids);
  }

  toggleVisible(ids: string[]): void {
    this.ids = selectAll(this.ids, ids, !ids.every(id => this.ids.has(id)));
  }
}
